export const Footer = () => {
  return (
    <div className="py-2 ml-2 flex bg-pink-50 items-center flex-col">
      <div className="flex justify-between">
        <span className="m-2 mr-[80px]">
          <span className="font-semibold m-1 hover:text-red-500">
            <p className="text-center">All Copyrights Reserved</p>
          </span>
        </span>
      </div>
    </div>
  );
};
